import {
  CustomEventNames,
  EventTypes,
  type ICRMEventsContext,
} from '@fhs-legacy/frontend/src/state/crm-events';
export class Logger {
  private crmLogger?: ICRMEventsContext['logRBIEvent'];

  constructor(private name: string) {}

  // Set CRM event logger for analytics tracking
  setCRMLogger(logger: ICRMEventsContext['logRBIEvent']): void {
    this.crmLogger = logger;
  }

  // Console logging for development and QA
  log(message: string, data?: any): void {
    if (process.env.NODE_ENV !== 'production') {
      // eslint-disable-next-line no-console
      console.log(`[${this.name}] ${message}`, data || '');
    }
  }

  logError(message: string, error?: any): void {
    // eslint-disable-next-line no-console
    console.error(`[${this.name}] ${message}`, error || '');
  }

  /**
   * Log to CRM analytics system
   * Use this for tracking conversion metrics and important events
   */
  logCRMEvent(eventName: string, attributes: Record<string, any> = {}): void {
    if (this.crmLogger) {
      try {
        this.crmLogger({
          name: CustomEventNames.CHECKOUT_PIPELINE_EVENT,
          type: EventTypes.Transaction,
          attributes: {
            component: 'PaymentPipeline',
            stepName: this.name,
            event: eventName,
            cart_version: 'fresh',
            ...attributes,
          },
        });
      } catch (error) {
        // Don't let CRM logging errors break the flow
        // eslint-disable-next-line no-console
        console.warn('Failed to log CRM event:', error);
      }
    }
  }
}
